import { API_STATES } from '@/helpers'

const employeeCostState = {
  costDataGetSate            : API_STATES.NOT_REQUESTED,
  costDataGetError           : null,
  costData                   : {},
  userBenefitEditMode        : false,
  userCostEditMode           : false,
  userCostsUpdateState       : API_STATES.NOT_REQUESTED,
  userCostsUpdateError       : null,
  userBenefitCostUpdateState : API_STATES.NOT_REQUESTED,
  userBenefitCostUpdateError : null
}

export default employeeCostState
